var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "todo_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2h36v44H6zM35 12H25M35 24H25M35 36H25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12l2 2 5-5M13 24l2 2 5-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 36,
    r: 3
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHRpdGxlPmxpc3Q8L3RpdGxlPjxnIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyNzI3MjYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiIHdpZHRoPSI1MCIgaGVpZ2h0PSI2MCI+PHBvbHlnb24gcG9pbnRzPSI2LDIgNiwyIDQyLDIgNDIsNDYgNiw0NiAiPjwvcG9seWdvbj4gPGxpbmUgeDE9IjM1IiB5MT0iMTIiIHgyPSIyNSIgeTI9IjEyIiBzdHJva2U9IiMyNzI3MjYiPjwvbGluZT4gPGxpbmUgeDE9IjM1IiB5MT0iMjQiIHgyPSIyNSIgeTI9IjI0IiBzdHJva2U9IiMyNzI3MjYiPjwvbGluZT4gPGxpbmUgeDE9IjM1IiB5MT0iMzYiIHgyPSIyNSIgeTI9IjM2IiBzdHJva2U9IiMyNzI3MjYiPjwvbGluZT4gPHBvbHlsaW5lIHBvaW50cz0iIDEzLDEyIDE1LDE0IDIwLDkgIiBzdHJva2U9IiMyNzI3MjYiPjwvcG9seWxpbmU+IDxwb2x5bGluZSBwb2ludHM9IiAxMywyNCAxNSwyNiAyMCwyMSAiIHN0cm9rZT0iIzI3MjcyNiI+PC9wb2x5bGluZT4gPGNpcmNsZSBjeD0iMTYiIGN5PSIzNiIgcj0iMyIgc3Ryb2tlPSIjMjcyNzI2Ij48L2NpcmNsZT48L2c+PC9zdmc+";
export { SvgTodo as ReactComponent };